import { ChangeDetectionStrategy, Component, Input, OnChanges } from '@angular/core';
import { CareerPlanLevel } from 'src/app/models/career-plans';

export interface LevelProgressData {
  levelName: string;
  progressPercentage: number;
}

@Component({
  selector: 'app-level-progress',
  templateUrl: './level-progress.component.html',
  styleUrls: ['./level-progress.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LevelProgressComponent implements OnChanges {
  ngOnChanges() {
    this.levelsProgressData = [];
    this.levels.forEach((level) =>
      this.levelsProgressData.push({
        levelName: level.name,
        progressPercentage: level.locked ? 0 : Math.ceil((100 * level.resourcesCompleted) / level.resourcesTotal),
      })
    );
  }

  @Input()
  levels: CareerPlanLevel[];

  levelsProgressData: LevelProgressData[] = [];
}
